import { BrancheEnum } from "@sgdf/client";
import type { Participant } from "@sgdf/ui-library";

export const sorterMap: Record<
  string,
  Record<string, (a: Participant, b: Participant) => number>
> = {
  "first_name": {
    "true": (a, b) =>
      (a.usage_first_name ?? a.first_name ?? "").localeCompare(
        b.usage_first_name ?? b.first_name ?? "",
      ),
    "false": (a, b) =>
      (b.usage_first_name ?? b.first_name ?? "").localeCompare(
        a.usage_first_name ?? a.first_name ?? "",
      ),
  },
  "last_name": {
    "true": (a, b) =>
      (a.usage_last_name ?? a.last_name ?? "").localeCompare(
        b.usage_last_name ?? b.last_name ?? "",
      ),
    "false": (a, b) =>
      (b.usage_last_name ?? b.last_name ?? "").localeCompare(
        a.usage_last_name ?? a.last_name ?? "",
      ),
  },
  "nobservations": {
    "false": (a, b) => (b.observation_count ?? 0) - (a.observation_count ?? 0),
    "true": (a, b) => (a.observation_count ?? 0) - (b.observation_count ?? 0),
  },
  "dailytaskteam": {
    "true": (a, b) =>
      (a.daily_task_team?.label ?? "").localeCompare(
        b.daily_task_team?.label ?? "",
      ),
    "false": (a, b) =>
      (b.daily_task_team?.label ?? "").localeCompare(
        a.daily_task_team?.label ?? "",
      ),
  },
  "branche": {
    "true": (a, b) =>
      (a.branche ?? BrancheEnum[0]).localeCompare(b.branche ?? BrancheEnum[0]),
    "false": (a, b) =>
      (b.branche ?? BrancheEnum[0]).localeCompare(a.branche ?? BrancheEnum[0]),
  },
};
